import(/* webpackMode: "eager" */ "/opt/trendrain/trendrain-web/src/app/terms/page.tsx");
